<template>
  <div class="metric-card">
    <div class="card-header">
      <img :src="burpeesImg" v-if="item.title.includes('Burpees')" height="56" width="56"/>
      <img :src="weighImg" v-if="item.title.includes('Weigh')" height="56" width="56"/>
      <img :src="mileImg" v-if="item.title.includes('Mile')" height="56" width="56">
      <img :src="howImg" v-if="item.title.includes('feel')" height="56" width="56"/>
      <div v-if="item.progress.length" class="stats-control">
          <svg
            aria-label="view excercise stat"
            @click="viewStats"
            width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.38462 17.5H2.5V11.5H5.38462V17.5ZM13.4615 17.5H10.5769V8.5H13.4615V17.5ZM17.5 17.5H14.6154V5H17.5V17.5ZM9.42308 17.5H6.53846V2.5H9.42308V17.5Z" fill="#8BDF06"/>
          </svg>
          Past stats  
      </div>
    </div>
    <h3 class="title">{{ item.title }}</h3>
    <div v-if="disabled" class="date-tag">
      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12V2.66667C12 1.93133 11.402 1.33333 10.6667 1.33333H9.33333V0H8V1.33333H4V0H2.66667V1.33333H1.33333C0.598 1.33333 0 1.93133 0 2.66667V12C0 12.7353 0.598 13.3333 1.33333 13.3333H10.6667C11.402 13.3333 12 12.7353 12 12ZM4 10.6667H2.66667V9.33333H4V10.6667ZM4 8H2.66667V6.66667H4V8ZM6.66667 10.6667H5.33333V9.33333H6.66667V10.6667ZM6.66667 8H5.33333V6.66667H6.66667V8ZM9.33333 10.6667H8V9.33333H9.33333V10.6667ZM9.33333 8H8V6.66667H9.33333V8ZM10.6667 4.66667H1.33333V3.33333H10.6667V4.66667Z" fill="white"/>
      </svg>
      Next entry -  {{ currentDateText }}
    </div>
    <div class="description">
      {{ item.description }}
    </div>
    <div class="card-footer">
      <button
        class="start-button"
        :class="{ 'disabled': disabled }"
        aria-label="open excercise entry"
        :disabled="disabled"
        @click="resultEntry">
        {{ disabled ? 'Submitted' : 'Submit' }}
      </button>
    </div>
  </div>
</template>

<script>
import weighImg from '@/assets/project300/weigh.png'
import burpeesImg from '@/assets/project300/burpees.png'
import mileImg from '@/assets/project300/mile.png'
import howImg from '@/assets/project300/how.png'
import moment from 'moment'
export default {
  name: 'metrics-card',
  props: {
    item: {
      type: Object,
    }
  },
  data() {
    return {
      weighImg: weighImg,
      burpeesImg: burpeesImg,
      mileImg: mileImg,
      howImg: howImg,
    }
  },
  computed: {
    currentDateText() {
      const now = moment()
      const day = now.date()
      if (day >= 1) {
        const firstOfNext = now.clone().add(1, 'month').startOf('month')
        return firstOfNext.format("MMM, YYYY")
      }
      return now.format("MMM, YYYY")
    },
    disabled() {
      let d = new Date()
      // let day = d.getDate()
      let month = d.getMonth()
      let last = this.item.progress.length ? this.item.progress[this.item.progress.length - 1].date : null
      // Use this variant after testing the template - disabled if last entry date is different than 1st of the month
      // return !last ? day !== 1 : new Date(last).getDate() === day || day !== 1

      // Use this variant for testing - disabled if last entry date is today
      // return new Date(last).getDate() === day

      // By the latest feedback...
      // This version - disabled if last entry date is in the current month
      return last ? new Date(last).getMonth() === month : false
    },
    disabledText() {
      let m = new Date()
      let month = m.getMonth()
      let x = this.item.progress.find(el => {
        let d = new Date(el.date)
        return d.getMonth() === month
      })

      return x && x.value !== '' ? 'Submitted' : 'Unsubmitted'
    }
  },
  methods: {
    resultEntry() {
      this.$emit('enter-result')
    },
    viewStats() {
      this.$emit('view-stats')
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/typography.scss";
.metric-card {
  background: #121212;
  border-radius: 8px;
  display: flex;
  flex-flow: column;
  padding: 24px;
  min-width: 264px;
  height: 324px;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .stats-control {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 14px;
      svg {
        margin-right: 4px;
        cursor: pointer;
      }
    }
  }

  .title {
    margin-top: 20px;
    font-size: 24px;
    font-weight: 700;
    font-family: $app-font;
  }

  .date-tag {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    padding: 8px 12px;
    border-radius: 23px;
    max-width: fit-content;
    border: 1px solid #404040;
    margin-top: 12px;
    text-transform: uppercase;

    svg {
      margin-right: 10px;
    }
  }

  .description {
    font-weight: 500;
    font-size: 14px;
    color: #c3c3c3;
    margin-top: 12px;
  }

  .card-footer {
    margin-top: auto;
    div {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 14px;
      font-weight: 600;
      font-family: $app-font;
    }

    .start-button {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 13px 24px;
      border-radius: 30px;
      border: 1px solid rgba(255, 255, 255, 0.4);
      width: 100%;
      font-weight: 700;
      text-transform: uppercase;
      &.disabled {
        opacity: 0.2;
      }
    }
  }
}
</style>